import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { Observable } from 'rxjs';
import { EnergyMeterRecord } from '@dto/energyMeterRecord';

@Injectable({
  providedIn: 'root'
})
export class EnergyMeterRecordsService extends EntityService {

  public entityRoute = "energyMeterRecords";

  constructor
    (
      http: HttpClient,
      @Inject('BASE_URL') baseUrl: string
    ) {
    super(http, baseUrl);
  }

  getDistribution(request): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}api/energyMeterRecords/distribution`, request);
  }

  getEnergyMonitorData(request): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}api/energyMeterRecords/monitorData`, request);
  }
}
